import { ButtonLink } from '@/components/Button'

import { Icon } from '@/components/Icon'

const CardFooter = ({
  url: link,
  title,
  handleOnClickCta,
}: {
  url?: string
  title?: string
  handleOnClickCta: () => void
}) => {
  if (!link) return null
  const ctaLabel = title && `Ler artigo sobre ${title}`

  return (
    <>
      <hr aria-hidden />
      <div className="blog-card__footer">
        <ButtonLink
          modifier="ghost"
          className="eu-al-center"
          source={link}
          aria-label={ctaLabel}
          onClick={handleOnClickCta}
        >
          Ler artigo completo <Icon icon="arrow-right" />
        </ButtonLink>
      </div>
    </>
  )
}

export default CardFooter
